module.exports = __webpack_public_path__ + "media/images/regions_old/Dosso-2678d9e135db9f1710d7aacdf2cd5a12.png";